<template>
  <div class="flex">
    <filter-field-default v-model="channelFilter">
      <option
        v-for="option in channelOptions"
        :key="option.value"
        :value="option.value"
      >{{ option.label }}
      </option>
    </filter-field-default>

    <filter-field-default
      label="status"
      v-model="statusFilter"
    >
      <option
        v-for="option in statusOptions"
        :key="option.value"
        :value="option.value"
      >{{ option.label }}
      </option>
    </filter-field-default>

    <filter-button-clear @click="resetFilters()"></filter-button-clear>
  </div>
</template>

<script>
import {computed} from "vue";
import {ENUMS} from "../../../services/enums";
import {useCampaignStore} from "../campaigns.store";

export default {
  name: "CampaignFilters",
  setup() {
    const campaignStore = useCampaignStore();

    const channelFilter = computed({
      get() {
        return campaignStore.filters.campaigns.channel;
      },
      set(newValue) {
        campaignStore.setCampaignsChannelFilter(newValue);
      }
    });
    const statusFilter = computed({
      get() {
        return campaignStore.filters.campaigns.status;
      },
      set(newValue) {
        campaignStore.setCampaignsStatusFilter(newValue);
      }
    });

    const channels = Object.entries(ENUMS.CampaignChannelEnum).map(([key, channel]) => {
      return {value: channel.value, label: channel.label};
    });

    const channelOptions = [
      {value: 0, label: "All Channels"},
      ...channels
    ];

    const statusOptions = campaignStore.filterOptions.campaignStatuses;

    function resetFilters() {
      campaignStore.resetCampaignsFilters()
    }

    return {
      channelFilter,
      statusFilter,
      channelOptions,
      statusOptions,
      resetFilters,
    };
  },
};
</script>
